import { Controller } from "@hotwired/stimulus";
import slugify from "slugify";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

import { checkAppmate, formatPrice } from "../helpers";
import { WishlistIcon } from "../components";
import PhotoSwipe from "photoswipe";
import { enableBodyScroll } from "body-scroll-lock-upgrade";

export default class extends Controller {
  static targets = [
    "variantSelector",
    "optionField",
    "form",
    "stockCount",
    "available",
    "discount",
    "saving",
    "quantity",
    "submit",
    "price",
    "colour",
    "carouselSlide",
    "stickyCTA",
    "wishlist",
    "preorderInfo",
    "preorderDate",
    "reviews",
    "description",
    "badge",
    "preorderWrap",
    "limit",
  ];

  static values = {
    tags: "",
    truncateActive: {
      type: Boolean,
      default: false,
    },
    badge: {
      image: "",
      has_background: false,
      text: "",
    },
    behaviour: "",
    url: "",
  };

  initialize() {

    // iOS Hack
    this.formTarget.addEventListener("touchstart", () => { });
    this.formTarget.addEventListener("touchend", () => { });
    this.formTarget.addEventListener("touchcancel", () => { });
    this.formTarget.addEventListener("touchmove", () => { });

    this.selectedVariant =
      this.variantSelectorTarget.querySelector("option:checked") || undefined;
    this.variantSelectorTarget.setAttribute("name", "id");
    this.filterImages();
    this.updateButtonState();
    this.updateBadge();

    this.isTrade = typeof trade_discount !== "undefined" ? true : false;
    this.samples = JSON.parse(document.body.dataset.samples);

    if (this.hasOptionFieldTarget) {
      this.handleUnavailableVariants(
        this.optionFieldTarget.querySelector(":checked")
      );
    }

    const wishlistCallback = () => {
      this.updateWishlistState();
    };
    checkAppmate(wishlistCallback);
  }

  handleSwatchChange(e) {
    e.preventDefault();
    const inputs = e.target.parentElement.querySelectorAll("input");

    inputs.forEach((input) => (input.checked = false));
    const target = e.target.querySelector("input");

    (target || e.target).checked = true;
    this.handleVariantChange(e);
  }

  handleVariantChange(e) {
    const fieldGroups = this.hasOptionFieldTarget
      ? this.optionFieldTargets
      : null;
    const variantOptions = [];

    if (fieldGroups) {
      fieldGroups.forEach((fieldGroup) => {
        let selector = fieldGroup.querySelector(":checked");
        if (!selector?.value)
          selector = fieldGroup.querySelector(".dropdown-input");

        variantOptions.push(selector.value);
      });
    }

    let selectedVariantOptions = variantOptions.join(":");

    // Handle colour combos
    selectedVariantOptions = slugify(
      selectedVariantOptions.split("/").join("-")
    );

    console.log("selectedVariantOptions", selectedVariantOptions, this.variantSelectorTarget);

    const newVariant = this.variantSelectorTarget.querySelector(
      `option[data-options="${selectedVariantOptions}"]`
    );

    if (newVariant) {
      if (this.hasColourTarget) {
        this.colourTarget.innerText = newVariant.innerText
          .split(" / ")[0]
          .trim();
      }

      this.selectedVariant = newVariant;
      newVariant.selected = true;

      const klaviyoNotifier = document.querySelector("[data-klaviyo-variant]");
      klaviyoNotifier.value = newVariant.value;

      this.updateStockNotification();
      this.updateMaxQuantity();
      this.updateQuantity(null, 1);
      this.updateButtonState();
      this.updatePrice();
      this.filterImages(true);
      this.handleUnavailableVariants(e.currentTarget);
      this.updateWishlistState();
      this.updateBadge();

      if (this.hasDescriptionTarget) {
        this.updateDescription();
      }

      if (
        window.location.pathname.includes("/products/") &&
        this.behaviourValue !== "quickshop"
      ) {
        this.handleURLUpdate();
      }
    } else {
      const colour = e.target.querySelector('input[name="colour"]');

      if (colour)
        this.colourTarget.innerText = colour.dataset.productOptionParam;

      console.log('robot rock');

      this.updateButtonState({ unavailable: true });

      console.warn(
        "Could not update variant: the selected variant does not exist"
      );
    }
  }

  // Disable any inputs or options if the combination does not exist
  handleUnavailableVariants(currentOption) {
    const options = Array.from(
      this.variantSelectorTarget.querySelectorAll("option")
    ).filter((option) =>
      slugify(option.dataset.options).includes(currentOption?.value)
    );

    if (options.length > 0) {
      this.optionFieldTargets.forEach((fieldGroup) => {
        // Get the select radios or dropdown options
        fieldGroup
          .querySelectorAll("input[name], select[name] option")
          .forEach((input) => {
            const name = input.name || input.parentElement.name || null;
            const currentOptionName =
              currentOption.name || currentOption.parentElement.name || null;

            if (name !== currentOptionName) {
              const optionExists = options.some((option) => {
                const value = option.dataset.options;

                if (
                  option.dataset.max <= 0 &&
                  option.dataset.available !== "true"
                ) {
                  if (input.nodeName !== "OPTION") {
                    input.parentElement.classList.add(
                      "product-form__radio--unavailable"
                    );
                  }
                } else {
                  input.parentElement.classList.remove(
                    "product-form__radio--unavailable"
                  );
                }

                return slugify(value).includes(input.value);
              });
            }
          });
      });
    }
  }

  // Toggle visibility of remaining stock count
  updateStockNotification() {
    this.stockCountTarget.innerText = this.selectedVariant.dataset.max;
    this.selectedVariant.dataset.available === "true"
      ? this.availableTarget.classList.add("hidden")
      : this.availableTarget.classList.remove("hidden");
  }

  // Update the max attribute of the quantity input field
  updateMaxQuantity() {
    const max = parseInt(this.selectedVariant.dataset.max);
    const stockMessage = this.stockCountTarget.parentElement;
    if (max > 0) {
      this.quantityTarget.max = max;
      this.quantityTarget.removeAttribute("data-preorder");
    } else {
      this.quantityTarget.removeAttribute("max");
      this.quantityTarget.setAttribute("data-preorder", "");
    }

    const threshold = stockMessage?.dataset?.stockThreshold || 10;

    if (max > 0 && max < threshold) {
      stockMessage.classList.remove("hidden");
    } else {
      stockMessage.classList.add("hidden");
    }
  }

  // Handle change of quantity on button click
  updateQuantity(e = undefined, quantity) {
    if (e) {
      e.preventDefault();
      const direction = e.params.direction;
      const quantity = parseInt(this.quantityTarget.value);

      if (direction === "increase") {
        if (
          !this.quantityTarget.max ||
          quantity < parseInt(this.quantityTarget.max)
        ) {
          this.quantityTarget.value++;
        }
      } else quantity > 1 && this.quantityTarget.value--;
    } else {
      this.quantityTarget.value = quantity;
    }

    const { options } = this.selectedVariant.dataset;
    const _options = options.split(":");

    if (_options.find((o) => o === "sample")) {
      const sampleInCart =
        this.samples.find((sample) => sample.id === this.selectedVariant.value)
          ?.quantity || 0;
      if (this.quantityTarget.value > 3 - sampleInCart) {
        this.limitTarget.classList.remove("hidden");
      } else {
        this.limitTarget.classList.add("hidden");
      }
    }

    this.updateButtonState();
  }

  // Change button action/message based on availability
  updateButtonState(props) {
    const { dataset } = this.selectedVariant;
    const field = this.hasPreorderWrapTarget
      ? this.preorderWrapTarget.querySelector('input[type="checkbox"]')
      : null;
    if (this.hasPreorderInfoTarget && this.hasPreorderWrapTarget) {
      this.preorderWrapTarget.classList.add("hidden");
      this.preorderDateTarget.innerText = dataset.preorderDate
        ? "The estimated date for dispatch is " + dataset.preorderDate
        : "";
      if (field) {
        field.required = false;
        field.disabled = true;
      }
    }

    // Handle a non-existent variant/option combination
    if (props?.unavailable) {
      this.stockCountTarget.parentElement.classList.add("hidden");
      return this.submitTargets.forEach((target) => {
        target.disabled = true;
        target.innerText = "Combination Unavailable";
      });
    } else {
      this.submitTargets.forEach((target) => {
        target.disabled = false;
      });
    }

    if (dataset.available === "false") {
      const isComingSoon =
        slugify(this.availableTarget.innerText, { lower: true }) ===
        "coming-soon" && !this.availableTarget.classList.contains("hidden");

      if (isComingSoon) {
        this.submitTargets.forEach(
          (target) => (target.innerText = "Notify me when available") // Coming Soon
        );
        this.formTarget.dataset.action = "product#handleComingSoon";
      } else {
        this.submitTargets.forEach(
          (target) => (target.innerText = "Notify me when Available")
        );
        this.formTarget.dataset.action = "product#notifyWhenAvailable";
      }
    } else {
      if (
        dataset.inventory === "continue" &&
        typeof this.quantityTarget.dataset.preorder !== "undefined" &&
        dataset.max <= 1
      ) {
        this.submitTargets.forEach(
          (target) => (target.innerText = "Pre-Order")
        );

        this.preorderInfoTarget.classList.remove("hidden");
        this.preorderWrapTarget.classList.remove("hidden");

        if (field) {
          field.disabled = false;
          field.required = true;
        }
      } else {
        const quantity = parseInt(this.quantityTarget.value) || 1;
        const totalPrice = parseInt(this.selectedVariant.dataset.price) * quantity;
        const formattedPrice = formatPrice(totalPrice, true, true);
        this.submitTargets.forEach(
          (target) => (target.innerText = `Add to Bag (${formattedPrice})`)
        );
      }

      this.formTarget.dataset.action = "product#addToCart";
    }
  }

  async addToCart(e) {
    e.preventDefault();

    let limitReached = false;
    let quantityToAdd = null;
    const limit = 3;
    const orderLimit = 40;

    const id = this.formTarget.querySelector('[name="id"]').value;
    let quantity = parseInt(
      this.formTarget.querySelector('[name="quantity"]').value
    );
    const samples = JSON.parse(document.body.dataset.samples);

    // Add any additional line item properties here:
    const { ccSku: _cc_sku, options } = this.selectedVariant.dataset;

    // Cap quantity for samples to 3 per item per order...
    if (options.split(":").find((option) => option === "sample")) {
      const sampleIndex = samples.findIndex((sample) => sample.id === id);

      if (sampleIndex >= 0) {
        if (quantity > limit - samples[sampleIndex].quantity) {
          limitReached = true;
        }

        quantityToAdd = Math.min(
          limit - samples[sampleIndex].quantity,
          quantity
        );
        samples[sampleIndex] = {
          id,
          quantity: Math.min(
            parseInt(samples[sampleIndex].quantity) + quantity,
            limit
          ),
        };
      } else {
        if (quantity > limit) {
          limitReached = true;
        }
        quantity = Math.min(quantity, limit);
        quantityToAdd = quantity;
        samples.push({ id, quantity });
      }

      const updatedSamples = JSON.stringify(samples);

      document.body.dataset.samples = updatedSamples;
    }

    const properties = {
      _cc_sku,
      _is_sample: options.includes("sample"),
    };

    const errorMessaging = (error) => {
      alert(
        `Sorry, there was an error adding the item to the bag: ${error?.description || error
        }`
      );
      console.error("There was an error adding the item to the bag", error);
    };

    if (options.includes("sample")) {
      const samples = JSON.parse(document.body.dataset.samples);
      const sampleTotal = samples
        .map((s) => s.quantity)
        .reduce((a, b) => a + b, 0);
      const limitDiff = 40 - sampleTotal;

      if (limitReached || limitDiff <= 0) {
        alert(
          `${limitReached ? "Samples are limited to 3 per colour" : ""} ${limitDiff <= 0 ? "You can only purchase 40 samples per order" : ""
          }`
        );
      }
      if (limitDiff > 0) {
        if (limitDiff <= 3) {
          quantityToAdd = Math.min(limitDiff, quantity);
        }
      } else {
        quantityToAdd = quantityToAdd + limitDiff;
      }

      if (
        quantityToAdd === 0 ||
        (quantityToAdd === 0 && limitDiff < 0) ||
        quantityToAdd === limitDiff
      )
        return;
    }
    try {
      enableBodyScroll(document.querySelector(".quickshop"));
      const res = await this.quickcartController.addToCart([
        {
          id,
          quantity: quantityToAdd || quantity,
          properties,
        },
      ]);
      if (typeof res === "string") {
        errorMessaging(res);
      } else {
        if (res.ok) {
          this.quickcartController.handleCart(this.element);
        } else {
          const error = await res.json();
          errorMessaging(error.description);
        }
      }

      return res;
    } catch (error) {
      errorMessaging(error);
    } finally {
      if (document.querySelector(".quickshop-wrap--active")) {
        document
          .querySelector(".quickshop-wrap--active")
          .classList.remove("quickshop-wrap--active");
      }
    }
  }

  handleComingSoon(e) {
    e.preventDefault();
    this.comingSoonController.togglePanel(
      e,
      this.selectedVariant,
      this.formTarget
    );
  }

  // Trigger notification panel
  notifyWhenAvailable(e) {
    this.stockNotifierController.togglePanel(
      e,
      this.selectedVariant,
      this.formTarget
    );
    e.preventDefault();
  }

  // Trigger Zoom
  triggerZoom() {
    this.element.querySelector(".splide__slide.is-active a").click();
  }

  // Display current variant price on variant change.
  updatePrice() {
    this.priceTargets.forEach((target) => {
      target.innerText = this.isTrade
        ? `Trade Price: ${formatPrice(
          this.selectedVariant.dataset.price,
          true,
          true
        )}`
        : formatPrice(this.selectedVariant.dataset.price, true, true);

      if (
        parseInt(this.selectedVariant.dataset.comparePrice) >
        parseInt(this.selectedVariant.dataset.price)
      ) {
        target.classList.add("price-group__price--on-sale");
      } else {
        target.classList.remove("price-group__price--on-sale");
      }
    });

    const price = parseInt(this.selectedVariant.dataset.price);
    const comparePrice =
      parseInt(this.selectedVariant.dataset.comparePrice) || price;

    if (price < comparePrice || this.isTrade) {
      if (this.hasDiscountTarget) {
        this.discountTargets.forEach(
          (target) =>
          (target.innerText = formatPrice(
            this.isTrade
              ? this.selectedVariant.dataset.price
              : this.selectedVariant.dataset.comparePrice
          ))
        );

        const altSale =
          this.selectedVariant.dataset.isAltSale === "true" ? true : false;

        this.discountTargets.forEach((target) => {
          target.classList.remove("hidden");
        });

        if (this.hasSavingTarget) {
          this.savingTargets.forEach((target) => {
            // Calc percentage
            const percentage = (price * 1.0) / comparePrice;
            const saving = Math.round((1 - percentage) * 100);

            if (saving > 0) {
              target.innerHTML = `${saving}% off`;
              target.classList.remove("hidden");
            } else {
              target.classList.add("hidden");
            }
          });
        }
      }
    } else {
      this.discountTargets.forEach((target) => target.classList.add("hidden"));

      if (this.hasSavingTarget) {
        this.savingTargets.forEach((target) => {
          target.classList.add("hidden");

          if (
            target.dataset.showAltSale &&
            target.dataset.overrideDiscount &&
            !(saving > 0)
          ) {
            target.innerHTML = target.dataset.showAltSale;
            target.classList.remove("hidden");
          }
        });
      }
    }
  }

  // Handle new images from #slide-images script and return
  // current variants images.
  filterImages(refresh = false) {
    const images = JSON.parse(
      this.element.querySelector("#slide-images")?.innerText ?? '{}'
    );

    if (!images || !images.length) {
      return;
    }

    const filteredImages = images.filter((image) => {
      //   let identifier = imagca.alt || "";

      //   if (identifier && identifier.includes("|")) {
      //     identifier = image.alt?.split("|");
      //   }

      //   if (typeof identifier !== "string" && identifier.length > 1) {
      //     identifier.pop();
      //     identifier = slugify(identifier.join(":")).toLowerCase() || null;
      //   } else {
      //     identifier = slugify(identifier.toLowerCase()) || "";
      //   }

      //   return (
      //     identifier.includes(slugify(this.selectedVariant.dataset.options)) ||
      //     (identifier.length > 0 &&
      //       slugify(this.selectedVariant.dataset.options).includes(identifier))
      //   );

      let parts = image.alt.split('|').map(s => s.toLowerCase().trim().replaceAll(' ', '-')).filter(s => !!s);
      let optionValues = this.selectedVariant.dataset.options.split(':').map(s => s.toLowerCase().trim()).filter(s => !!s);

      if (!parts.length) {
        return true;
      }

      //if all of the parts of the image alt match all of the selected product variant option values show image
      return parts.filter(part => optionValues.includes(part)).length == optionValues.length
    });

    if (filteredImages.length > 0) {
      const carousels = this.element.querySelectorAll(".splide__list");

      carousels.forEach((carousel) => {
        carousel.innerHTML = "";
        filteredImages.forEach(
          (image) =>
          (carousel.innerHTML +=
            this.behaviourValue === "quickshop"
              ? `
                <li class="splide__slide product-main__carousels-item" data-product-target="carouselSlide">
                  <a href="${this.urlValue +
              (this.selectedVariant?.value
                ? `?variant=${this.selectedVariant.value}`
                : "")
              }">
                    <img
                      height="575"
                      width="575"
                      src="${image.base_src}"
                      alt="${image.alt}"
                      loading="lazy"
                    />
                  </a>
                </li>`
              : `
          <li class="splide__slide product-main__carousels-item" data-product-target="carouselSlide">
            ${carousel.dataset.carousel === "main"
                ? `
                <a
                  href="${image.main_src}"
                  data-pswp-src="${image.main_src}"
                  data-pswp-width="1150"
                  data-pswp-height="1150"
                  target="_blank"
                >
                  <img
                    height="575"
                    width="575"
                    src="${image.base_src}"
                    alt="${image.alt}"
                    loading="lazy"
                  />
                </a>
              `
                : `
                <img
                  src="${image.thumb_src}"
                  height="140"
                  width="140"
                  alt="${image.alt}"
                  loading="lazy"
                />
              `
              }
          </li>
          `)
        );
      });

      if (refresh) {
        this.carouselController.handleMount(this.element);
      }
    }

    this.handleProductZoom();
  }

  // Replace URL param with current variant ID
  handleURLUpdate() {
    const id = this.selectedVariant.value;
    history.replaceState(
      null,
      document.title,
      `${window.location.origin}${window.location.pathname}?variant=${id}`
    );
  }

  // Toggle visibility of fixed add to cart button
  handleStickyBarScroll() {
    const target = this.stickyCTATarget;
    const _class = "product-sticky-cta--visible";
    const buttonRef = document.querySelector(
      'button[data-product-button="main"]'
    );

    const stickyBarHeight = target.getBoundingClientRect().height;
    document.body.style.setProperty('--sticky-atc-bar-height', `${stickyBarHeight}px`);

    if (buttonRef && buttonRef.getBoundingClientRect().y < 0) {
      target.classList.add(_class);
      document.body.classList.add(_class);
    } else {
      target.classList.remove(_class);
      document.body.classList.remove(_class);
    }
  }

  openLightbox(e) {
    this.lightboxController.toggleLightbox(e.currentTarget);
  }

  // Update Badge when variant changes
  updateBadge() {
    const price = this.selectedVariant.dataset.price;
    const comparePrice = this.selectedVariant.dataset.comparePrice;
    // const limitedSale = document.body.dataset.limitedSale;
    const limitedSale = document.getElementById('limited_sale_json')?.innerText;

    if (!limitedSale) return;

    const { sale_tag, icon, text, sale_from, sale_to } =
      JSON.parse(limitedSale);
    const saleStart = Date.parse(sale_from);
    const saleEnd = Date.parse(sale_to);
    const present = Date.now();

    if (
      parseInt(price) < parseInt(comparePrice) &&
      this.tagsValue.includes(sale_tag) &&
      present < saleEnd &&
      present > saleStart
    ) {
      this.badgeTarget.innerHTML = `
          <div class="badge">
          ${icon
          ? `
            <img
              class="badge__image"
              src="${icon}"
              height="44"
              width="44"
              alt="${text}"
            />
            `
          : ""
        }
            ${text ? `<p class="badge__text">${text}</p>` : ""}
          </div>
        `;
    } else if (this.tagsValue.includes("WLT")) {
      this.badgeTarget.innerHTML = `
        <div class="badge badge--nature">
          <img
            class="badge__image"
            src="${document.body.dataset.wltImage}"
            height="44"
            width="80"
            alt="Tree Donation"
          />
          <p class="badge__text">Tree Donation</p>
        </div>
      `;
    } else {
      const { icon, text, has_background } = this.badgeValue;
      this.badgeTarget.innerHTML = `
        <div class="badge ${has_background === "true" ? "badge--pink" : ""}">
            ${icon
          ? `
              <img
                class="badge__image"
                src="${icon}"
                height="44"
                width="44"
                alt="${text}"
              />
              `
          : ""
        }
              ${text ? `<p class="badge__text">${text}</p>` : ""}
            </div>
      `;
    }
  }

  // Show wishlist state of given variant upon change
  updateWishlistState() {
    const variantId = this.selectedVariant.value;
    if (!Object.hasOwn(this, 'wishlistTarget')) return;
    const { productId } = this.wishlistTarget.dataset;
    this.wishlistTarget.innerHTML = WishlistIcon(variantId, productId);
  }

  // Handle Truncate
  handleTruncate() {
    this.truncateActiveValue = !this.truncateActiveValue;
  }

  getDescription() {
    if (
      this.hasColourTarget &&
      this.hasDescriptionTarget &&
      this.descriptionTarget.dataset.colourDescriptions
    ) {
      const colour = this.colourTarget.innerText;
      const descriptions = JSON.parse(
        this.descriptionTarget.dataset.colourDescriptions
      );

      if (!descriptions.color_name) {
        return this.descriptionTarget.dataset.description;
      }

      const index = descriptions.color_name.findIndex(
        (color) => color === colour
      );

      if (index >= 0) {
        return descriptions.description[index];
      }
    }

    return this.descriptionTarget.dataset.description;
  }

  truncateActiveValueChanged(value) {
    if (this.hasDescriptionTarget) {
      const description = this.getDescription();
      if (description) {
        if (description.length > 220) {
          if (value === false) {
            this.descriptionTargets.forEach(
              (target) =>
              (target.innerHTML = `
                ${description.substring(0, 220)}...
                <span class="product-main__truncate" data-action="click->product#handleTruncate">see more</span>
              `)
            );
          } else {
            this.descriptionTargets.forEach(
              (target) =>
              (target.innerHTML = `
                ${description}
                <span class="product-main__truncate" data-action="click->product#handleTruncate">see less</span>
              `)
            );
          }
        } else {
          this.descriptionTargets.forEach(
            (target) =>
            (target.innerHTML = `
              ${description}
            `)
          );
        }
      }
    }
  }

  updateDescription() {
    if (this.hasDescriptionTarget) {
      const description = this.getDescription();
      if (description) {
        this.descriptionTargets.forEach(
          (target) =>
          (target.innerHTML = `
              ${description.length > 220
              ? `${description.substring(0, 220)}...`
              : description
            }
              <span class="product-main__truncate" data-action="click->product#handleTruncate">see more</span>
            `)
        );
        this.truncateActiveValue = false;
      }
    }
  }

  handleReadMore(e) {
    e.preventDefault();
    const accordion = document.getElementById('description-accordion');
    if (!accordion) return;
    const head = accordion.querySelector('.js-accordion-head');
    if (head && !head.classList.contains('accordion__head--active')) {
      head.click();
    }
    accordion.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  handleProductZoom() {
    const lightbox = new PhotoSwipeLightbox({
      zoom: false,
      closeSVG:
        '<svg style="height: 24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73l183 183L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183L407 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183-183L441 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-183 183L41 39z"/></svg>',
      gallery: ".product-main__carousel",
      children: "a",
      showHideAnimationType: "fade",
      preloaderDelay: 500,
      pswpModule: () => PhotoSwipe,
      secondaryZoomLevel: () => (window.innerWidth > 768 ? 1.75 : 1),
    });

    lightbox.init();
  }

  // Controller Getters
  get carouselController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "carousel";
    });
  }

  get quickcartController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "quickcart";
    });
  }

  get lightboxController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "lightbox";
    });
  }

  get stockNotifierController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "stock-notifier";
    });
  }

  get comingSoonController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "coming-soon";
    });
  }
}